<template>
  <form data-abide2 novalidate data-vv-scope="form5" @submit.prevent="goToStep5" dusk="registration-step-5" class="step" :style="{'justify-content':buttonToTop ? 'flex-start' : 'center','flex-flow' : buttonToTop ? 'column' : 'wrap'}">
    <div class="form-inner">
      <div class="headline" v-html="trans('reg.enter_email_address')"></div>
      <label>
        <input class="form-control dark"
               type="email"
               dusk="login"
               autocomplete="username"
               id="email"
               v-bind:placeholder="trans('email')"
               v-bind:data-vv-as="trans('email').toLowerCase()"
               required
               v-model="email"
               v-validate="'required|email'"
               :class="{'is-invalid-input': errors.has('form5.email')}"
               name="email">

        <span class="form-error" :class="{'is-visible': errors.has('form5.email')}">
                          {{ errors.first('form5.email') }}
                        </span>
      </label>
    </div>
    <div class="form-footer">
      <button :disabled="!email || errors.has('form5.email')" class="btn btn-primary btn-long btn-rounded" id="button4" type="submit">
        {{ trans('reg.next') }}
      </button>
    </div>
  </form>
</template>

<script>
import _ from "lodash";
export default {
  mixins: [require('@general/lib/mixin').default],
  props: ['vars'],
  data() {
    return this.vars;
  },
  components: {
  },
  methods: {

    async goToStep5() {
      this.showLoadingButton('#button4')
      let response = await axios.post('/api/register/validate-email', {email: this.email})
      if (response.data.success) {
        //for browser remember password alert
        this.step = 5;
      }else{
        this.errors.add({
          field: 'form4.email',
          msg: response.data.errors.email[0]
        });
      }
      this.restoreLoadingButton('#button4')
    },

  },
  mounted() {
    let email = document.getElementById('email');

    let self = this;
    if(this.isMobile) {
      email.addEventListener("focus", () => {
        self.buttonToTop = true;
      })
      email.addEventListener("blur", () => {
        self.buttonToTop = false;
      })
      document.getElementById('button4').addEventListener('touchend', (e) => {
        if(!(!this.email || this.errors.has('form5.email'))){
          this.goToStep5(e)
        }
      });
    }

    if(this.buttonToTop || this.isDesktop) {
      document.getElementById('email').focus();
    }
  },
}
</script>
